import { render, staticRenderFns } from "./DataAp.vue?vue&type=template&id=fccd294a&scoped=true&"
import script from "./DataAp.vue?vue&type=script&lang=js&"
export * from "./DataAp.vue?vue&type=script&lang=js&"
import style0 from "./DataAp.vue?vue&type=style&index=0&id=fccd294a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fccd294a",
  null
  
)

export default component.exports